module.exports = /./.exec;